'use strict';

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _defineProperty = require("/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/objectWithoutProperties");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

var _slicedToArray = require("/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: !0
});

function _interopDefault(a) {
  return a && "object" == typeof a && "default" in a ? a["default"] : a;
}

var apolloLinkHttp = require("apollo-link-http"),
    apolloLinkContext = require("apollo-link-context"),
    Prismic = _interopDefault(require("prismic-javascript"));

function removeWhiteSpace(a) {
  var b = /(%0A|%20)*(%20|%7B|%7D)(%0A|%20)*/g,
      _a$split = a.split("?"),
      _a$split2 = _slicedToArray(_a$split, 2),
      c = _a$split2[0],
      d = _a$split2[1];

  if (!d) return a;
  var e = d.split("&").map(function (a) {
    var _a$split3 = a.split("="),
        _a$split4 = _slicedToArray(_a$split3, 2),
        c = _a$split4[0],
        d = _a$split4[1];

    return "query" === c ? c + "=" + d.replace(b, function (a, b, c) {
      return c;
    }) : a;
  }).join("&");
  return [c, e].join("?");
}

var PRISMIC_ENDPOINT_REG = /^https?:\/\/([^.]+)\.(?:cdn\.)?(wroom\.(?:test|io)|prismic\.io)\/graphql\/?/;

function parsePrismicEndpoint(a) {
  var b = a.match(PRISMIC_ENDPOINT_REG);

  if (null !== b && Array.isArray(b) && 3 === b.length) {
    var _b = _slicedToArray(b, 3),
        _a = _b[1],
        c = _b[2];

    return "https://".concat(_a, ".cdn.").concat(c);
  }

  return null;
}

function PrismicLink(_ref) {
  var a = _ref.uri,
      b = _ref.accessToken,
      c = _ref.repositoryName,
      d = _objectWithoutProperties(_ref, ["uri", "accessToken", "repositoryName"]);

  var e = parsePrismicEndpoint(a);
  if (e && c && console.warn("`repositoryName` is ignored since the graphql endpoint is valid."), !e && !c) throw Error("Since you are using a custom GraphQL endpoint, you need to provide to PrismicLink your repository name as shown below:\nPrismicLink({\n  uri: 'https://mycustomdomain.com/graphql',\n  accessToken: 'my_access_token', // could be undefined\n  repositoryName: 'my-prismic-repository'\n})\n");
  var f, g;
  e ? (f = "".concat(e, "/api"), g = "".concat(e, "/graphql")) : (f = "https://".concat(c, ".cdn.prismic.io/api"), g = a);
  var h = Prismic.client(f, {
    accessToken: b
  }),
      i = apolloLinkContext.setContext(function (a, c) {
    return h.getApi().then(function (a) {
      return {
        headers: _objectSpread(_objectSpread(_objectSpread({
          "Prismic-ref": a.masterRef.ref
        }, c.headers), a.integrationFieldRef ? {
          "Prismic-integration-field-ref": a.integrationFieldRef
        } : {}), b ? {
          Authorization: "Token ".concat(b)
        } : {})
      };
    });
  }),
      j = new apolloLinkHttp.HttpLink(_objectSpread({
    uri: g,
    useGETForQueries: !0,
    fetch: function (_fetch) {
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function (a, b) {
      var c = removeWhiteSpace(a);
      return fetch(c, b);
    })
  }, d));
  return i.concat(j);
}

var index = {
  PrismicLink: PrismicLink
};
exports.PrismicLink = PrismicLink, exports.default = index;